const payrollDepartmentData = [
  { label: 'Jan', cost: 5000},
  { label: 'Feb', cost: 7000 },
  { label: 'Mar', cost: 3000},
  { label: 'Apr', cost: 5000},
  { label: 'May', cost: 9000},
  { label: 'Jun', cost: 4500},
  { label: 'Jul', cost: 11000},
  { label: 'Aug', cost: 4000},
  { label: 'Sep', cost: 8000},
  { label: 'Oct', cost: 6000},
  { label: 'Nov', cost: 10000},
  { label: 'Dec', cost: 7000}
];

const PayrollCostChartConfig = (
  datas = payrollDepartmentData,
  xKey = 'label',
  barKey = 'cost',
  barLabel = 'Cost'
) => {

  return {
    color: ['#1e6d6a', '#1e6d6a'],
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const bar = params.find(p => p.seriesName === barLabel);
        return `
          <b>${bar?.name}</b><br/>
           ${barLabel}: $${bar?.value ?? 0}<br/>
        `;
      }
    },
    legend: {
      show: false,
      bottom: 0,
      data: [barLabel]
    },
    grid: {
      left: 10,
      right: 10,
      bottom: 40,
      top: 20,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: datas.map(d => d[xKey]),
      axisLabel: { interval: 0 }
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: barLabel,
        type: 'bar',
        barWidth: 35,
        data: datas.map(d => d[barKey]),
        itemStyle: {
          color: '#1e6d6a',
          borderRadius: [6, 6, 0, 0]
        },
        z: 1
      }
     
    ]
  };
};

export default PayrollCostChartConfig;
